import { redirect } from 'react-router';

export function requireAuth() {
  if (!localStorage.getItem('lunar-grid-authenticated')) {
    return redirect('/login');
  }
  return null;
}
